// extracted by mini-css-extract-plugin
module.exports = {"cartProduct":"CartProduct_cartProduct__3QstU","cartSides":"CartProduct_cartSides__3wv6f","quantity":"CartProduct_quantity__24Ljr"};